<template>
  <div class="LKPublicationsCardRecommendationAggregatedCsv">
    <div class="LKPublicationsCardRecommendationAggregatedCsv__title">
      Генерация административных профилей
    </div>

    <div class="LKPublicationsCardRecommendationAggregatedCsv__description">
      Блок для создания ZIP архивов с результатами. Выберите тип профиля,
      загрузите CSV или выберите через дерево АТЕ необходимые логины ОО и
      отслеживайте выполнение в таблице ниже.
    </div>

    <div class="LKPublicationsCardRecommendationAggregatedCsv__controls">
      <v-select
        v-model="profileType"
        :items="profileTypeItems"
        label="Тип профиля"
        item-text="text"
        item-value="value"
        outlined
        dense
        hide-details="auto"
        class="LKPublicationsCardRecommendationAggregatedCsv__profile-type"
      />

      <BFileInput
        v-model="file"
        accept=".csv,text/csv"
        label="CSV файл с логинами..."
        small-chips
        show-size
        hide-details="auto"
        class="LKPublicationsCardRecommendationAggregatedCsv__file"
        @change="onFileChange"
      />

      <v-btn
        color="primary"
        outlined
        small
        :loading="isUploading"
        :disabled="!canUpload"
        class="LKPublicationsCardRecommendationAggregatedCsv__button"
        @click="onUpload"
      >
        Запустить по CSV
      </v-btn>

      <v-btn
        color="primary"
        outlined
        small
        class="LKPublicationsCardRecommendationAggregatedCsv__button"
        @click="$emit('open-modal')"
      >
        Выбрать по дереву АТЕ
      </v-btn>
    </div>
  </div>
</template>

<script>
import BFileInput from '@/components/forms/BFileInput.vue'
import { LkRecomendationApi } from '@/api/resources'

const PROFILE_TYPE_ITEMS = [
  { text: 'Административный профиль', value: 'adm' },
  { text: 'Региональный профиль', value: 'reg' },
  { text: 'Школьный профиль', value: 'sch' },
]

export default {
  name: 'LKPublicationsCardRecommendationAggregatedCsv',
  components: {
    BFileInput,
  },
  props: {
    publicationId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    file: null,
    profileType: 'sch',
    profileTypeItems: PROFILE_TYPE_ITEMS,
    isUploading: false,
  }),
  computed: {
    canUpload() {
      return Boolean(this.file && this.profileType && !this.isUploading)
    },
  },
  methods: {
    onFileChange(file) {
      this.file = file
    },
    async onUpload() {
      const api = new LkRecomendationApi()
      this.isUploading = true

      try {
        const result = await api.generateAggregatedFromCsv(
          this.publicationId,
          this.profileType,
          this.file,
        )
        this.file = null
        this.$notice.info('Запущена генерация профилей из CSV')
        this.$emit('generated', result)
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isUploading = false
      }
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsCardRecommendationAggregatedCsv {
  margin-top: 12px;

  &__title {
    margin-bottom: 8px;
    font-size: 13px;
    font-weight: 600;
  }

  &__description {
    max-width: 760px;
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.62);
    font-size: 12px;
    line-height: 1.45;
  }

  &__controls {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
    align-items: center;
  }

  &__profile-type {
    flex: 1 1 250px;
    max-width: 320px;
  }

  &__file {
    flex: 1 1 320px;
    max-width: 420px;
  }

  &__button {
    min-height: 40px;
    margin-top: 0 !important;
  }
}
</style>
